import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import FormInput from "../components/FormInput";
import {
  useGetCibilCredentialQuery,
  useGetCodeValuesQuery,
} from "../slices/getqueries/getqueriesApi";
function NewCibilCredential() {
    const { userInfo } = useSelector((state) => state.auth);
    const { clientId } = userInfo;
    const [documentExists, setDocumentExists] = useState(false);
    const [mappedValue, setMappedValue] = useState({});
    const { data: currentResponseData } = useGetCibilCredentialQuery({
      clientname: clientId,
    });
  
    const { data: codevalues } = useGetCodeValuesQuery();
    const codeValuesArray = codevalues
      ? Object.values(codevalues).map((item) => item.name)
      : [];
    const fieldsObject = codevalues
      ? Object.values(codevalues).map((item) => ({
          name: item.name,
          fields: item.fields,
        }))
      : [];
    const fields = fieldsObject.reduce((acc, curr) => {
      acc[curr.name] = curr.fields;
      return acc;
    }, {});
  return (
    <>
    <p className="font-[600] text-[20px] text-[#212121] mb-3">Credentials</p>
    <div className="p-6 md:p-16 bg-white rounded-[15px] w-full">
      <h2 className="text-[22px] font-[600] text-center mb-2">
        Add or Update Your CIBIL Credentials
      </h2>
      <p className="text-lg text-[#212121] text-center mb-6 max-w-[600px] mx-auto font-[400]">
        Ensure accurate credit integration and faster loan approvals by
        creating or updating your CIBIL credentials.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {codeValuesArray.map((key, idx) => {
          const formTitle = key.split(" ")[0] || "";
          const formSubtitle = key.replace(formTitle, "").trim();
          const dataExists = mappedValue[key];
          const formFields = fields[key] || [];

          return (
            <div key={idx} className="border rounded-[15px] p-6 shadow-sm space-y-4">
              <h3 className="font-semibold text-[15px] text-[#204887]">
                <span className="font-bold text-[16px]">{formTitle ? formTitle.charAt(0).toUpperCase() + formTitle.slice(1) : ""}:</span> {formSubtitle}
              </h3>

              {formFields.map((field, i) => (
                <div key={i}>
                  <label className="text-[10px] font-[500] block text-[#4B5563] mb-2 ml-2">
                  {field ? field.charAt(0).toUpperCase() + field.slice(1) : ""}
                  </label>
                  {field.type === "file" ? (
                    <input
                      type="file"
                      className="w-full px-3 py-2 border border-[#204887] rounded-md text-sm"
                    />
                  ) : (
                    <input
                      type={field.type || "text"}
                      placeholder={`Enter ${field ? field.charAt(0).toUpperCase() + field.slice(1) : ""}
                      `}
                      className="w-full px-5 py-5 border rounded-[10px] text-[12px]"
                    />
                  )}
                </div>
              ))}
              <div className="flex justify-end mt-2">
              <button className="mt-2 px-20 py-5 rounded-[10px] bg-[#204887] text-white text-[12px] font-medium hover:bg-[#183a6c]">
                {dataExists ? "Update" : "Create"}
              </button>
                </div>
            </div>
          );
        })}
      </div>
    </div>
    </>
  )
}

export default NewCibilCredential
